import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  Inject,
} from '@angular/core';
import { WindowLayoutService } from '@app/shared/services/window-layout/window-layout.service';

@Component({
  selector: 'dgx-task-alert',
  templateUrl: './task-alert.component.html',
  styleUrls: ['./task-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskAlertComponent implements OnInit {
  @Input() public header: string;
  @Input() public description: string;
  @Input() public actionLabel: string;
  @Input() public url: string;

  @Output() public onAction: EventEmitter<any> = new EventEmitter();

  constructor(private windowLayoutService: WindowLayoutService) {}

  public ngOnInit(): void {
    if (!this.actionLabel && this.showAction) {
      throw Error(
        'TaskAlertComponent => `actionLabel` is required if `url` or `onAction` are present'
      );
    }
  }

  public handleAction(event: Event): void {
    this.onAction.emit(event);
  }

  public get isMobile(): boolean {
    return this.windowLayoutService.isMobile;
  }

  public get showAction(): boolean {
    return !!this.url || !!this.onAction.observers.length;
  }

  public get role(): 'button' | undefined {
    return !this.url ? 'button' : undefined;
  }
}
